export const BASE_URL = "https://tours-and-travels-sv4s.onrender.com/api/v1";
